/*!
* jQuery lightweight plugin boilerplate
* Original author: @ajpiano
* Further changes, comments: @addyosmani
* Licensed under the MIT license
*/

import jQuery from 'jquery';

(function ($, window, document, undefined) {
	// Create the defaults once
	var pluginName = 'fakeSelect',
		defaults = {
			isColour: false
		};

	// The actual plugin constructor
	function FakeSelect(element, options) {
		this.element = element;
		this.$element = $(element);

		this.options = $.extend({}, defaults, options);
		this._defaults = defaults;
		this._name = pluginName;
		this.init();
	}

	FakeSelect.prototype.init = function () {
		this.$element.hide();

		this.$fakeSelect = this._buildFakeSelect(this.options.isColour);

		this.$element.after(this.$fakeSelect);
		this.$fakeSelect.data('fake-select-select', this.$element);
		this.$element.data('fake-select-fake', this.$fakeSelect);

		this._processChange.call(this.$element);

		this.initEvents();
	};

	FakeSelect.prototype.initEvents = function () {
		this.$element.on('change', this._processChange);

		$('body').on('click', $.proxy(this._processClick, this));
	};

	FakeSelect.prototype._processChange = function () {
		var $this = $(this),
			$fakeSelect = $this.data('fake-select-fake'),
			$selected,
			val = $this.val();

		if (!(val instanceof Array)) {
			val = [val];
		}

		$selected = $fakeSelect.find('.fake-select__option.is-selected');
		$selected.removeClass('is-selected');
		$selected = $fakeSelect.find('.fake-select__option').filter(function () {
			return val.indexOf($(this).data('fake-select-val')) !== -1;
		});

		if (!$selected.length) {
			$selected = $fakeSelect.find('.fake-select__option').first();
		}
		$selected.addClass('is-selected');
	};

	FakeSelect.prototype._processClick = function (e) {
		var $fakeSelect = this.$fakeSelect,
			$element = this.$element,
			$target,
			oldVal, newVal,
			isMultiple,
			openClass = 'is-open';

		$target = $(e.target);

		if ($target.closest(this.$fakeSelect).length) {
			if ($fakeSelect.hasClass(openClass)) {
				isMultiple = $element.prop('multiple');
				newVal = $target.closest('.fake-select__option').data('fake-select-val');

				if (isMultiple) {
					oldVal = $element.val() || [];
					if (oldVal.indexOf(newVal) === -1) {
						oldVal.push(newVal);
					} else {
						oldVal.splice(oldVal.indexOf(newVal), 1);
					}
					$element.val(oldVal);
				} else {
					$fakeSelect.removeClass(openClass);
					$element.val(newVal);
				}

				$element.trigger('change');
			} else {
				$fakeSelect.addClass(openClass);
			}
		} else {
			$fakeSelect.removeClass(openClass);
		}
	};

	FakeSelect.prototype._buildFakeSelect = function (isColour) {
		var fakeSelect, optionClass,
			$select = this.$element,
			$options = $select.find('option'),
			$option,
			i;

		if (isColour) {
			fakeSelect = '<div class="fake-select__wrapper"><div class="fake-select fake-select--colour"><ul class="grid">';
			for (i = 0; i < $options.length; i++) {
				$option = $select.find('option:eq(' + i + ')');
				colour = $option.val();
				fakeSelect += '<li class="grid__item one-fifth fake-select__option" data-fake-select-val="' + $option.val() + '">';
				fakeSelect += '<span class="fake-select__colour ' + colour + '"></span>';
				fakeSelect += '</li>';
			}
			fakeSelect += '</ul></div></div>';
		} else {
			fakeSelect = '<div class="fake-select__wrapper"><ul class="fake-select">';
			for (i = 0; i < $options.length; i++) {
				$option = $select.find('option:eq(' + i + ')');
				optionClass = 'fake-select__option';
				fakeSelect += '<li class="' + optionClass + '" data-fake-select-val="' + $option.val() + '">' + $($options[i]).text() + '</li>';
			}
			fakeSelect += '</ul></div>';
		}

		return $(fakeSelect);
	};

	$.fn[pluginName] = function (options) {

		return this.each(function () {
			if (!$.data(this, "plugin_" + pluginName)) {
				$.data(this, "plugin_" + pluginName,
					new FakeSelect(this, options));
			}
		});

	};

})(jQuery, window, document);
